// extracted by mini-css-extract-plugin
export default {"wikiDetails":"wikiDetails_wikiDetails__LmhD1","wikiName":"wikiDetails_wikiName__in7Cg"};